import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

const Index = () => import('./Index.vue');
const CrmManual = () => import('./CrmManual.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/manuais'),
    name: 'manuais_index',
    component: Index,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
  },
  {
    path: frontendURL('accounts/:accountId/manuais/crm'),
    name: 'manuais_crm',
    component: CrmManual,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
  },
];
